export function estimateReadingTime(text) {
  // Minimum estimated reading time in minutes
  const minReadingTimeMinutes = 1;

  // Average reading speed in words per minute
  const readingSpeed = 200;

  // Calculate estimated reading time in minutes
  const wordCount = text.split(/\s+/).length;
  const readingTimeMinutes = wordCount / readingSpeed;

  // Ensure a minimum reading time and round to the next integer
  return Math.ceil(Math.max(readingTimeMinutes, minReadingTimeMinutes));
}

export const findTop3RepeatedWords = (text) => {
  // List of common syncategorematic stop words
  const stopWords = new Set([
    "I",
    "the",
    "to",
    "and",
    "was",
    "a",
    "of",
    "my",
    "me",
    "that",
  ]);

  // Convert text to lowercase and split it into words
  const words = text.toLowerCase().match(/\w+/g);

  // Create an object to store word frequencies
  const wordFrequency = {};

  // Count word frequencies, excluding stop words
  words.forEach((word) => {
    if (!stopWords.has(word)) {
      wordFrequency[word] = (wordFrequency[word] || 0) + 1;
    }
  });

  // Sort words by frequency in descending order
  const sortedWords = Object.keys(wordFrequency).sort(
    (a, b) => wordFrequency[b] - wordFrequency[a]
  );

  // Get the top 3 words and their frequencies
  const topWords = sortedWords.slice(0, 3).map((word) => ({
    word,
    frequency: wordFrequency[word],
  }));

  return topWords;
};

export function calculateContentAnalytics(text) {
  const words = text.split(/\s+/);
  const wordCount = words.length;
  const characterCount = text.length;
  const totalWordLength = words.reduce((sum, word) => sum + word.length, 0);
  const averageWordLength =
    wordCount > 0 ? Math.floor(totalWordLength / wordCount) : 0;

  return {
    wordCount,
    characterCount,
    averageWordLength,
  };
}
